import moment from 'moment-timezone';
import {
	ANALYTICS_TIME_ZONE_PARAM_NAMES,
	encodeUTCAdjustedDate,
	formatDateForParam,
} from './DataFormatterUtils';
import { ANALYTICS_DEFAULT_TIME_ZONE } from './DataConstants';

export enum ANALYTICS_UPPER_BOUND {
	INCLUSIVE = 'inclusive',
	EXCLUSIVE = 'exclusive',
}

const DATE_PAIRS = [
	['startDate', 'endDate', 'timeZone'],
	['workCreatedAtStartDate', 'workCreatedAtEndDate', 'workCreatedAtTimeZone'],
	['workCompletedAtStartDate', 'workCompletedAtEndDate', 'workCompletedAtTimeZone'],
];

export const formatAnalyticsStartDate = (value, timeZone = ANALYTICS_DEFAULT_TIME_ZONE) =>
	value ? formatDateForParam(encodeUTCAdjustedDate(value, false, timeZone)) : undefined;

export const formatAnalyticsEndDate = (
	value,
	upperBound,
	timeZone = ANALYTICS_DEFAULT_TIME_ZONE
) => {
	if (!value) return undefined;
	// Exclusive: bound as start of the day after the selected end (`created_at < end`).
	return upperBound === ANALYTICS_UPPER_BOUND.EXCLUSIVE
		? formatDateForParam(encodeUTCAdjustedDate(moment(value).add(1, 'day'), false, timeZone))
		: formatDateForParam(encodeUTCAdjustedDate(value, true, timeZone));
};

export const buildAnalyticsDateParams = (params, upperBound) => {
	const next = { ...(params || {}) };

	DATE_PAIRS.forEach(([startName, endName, timeZoneName]) => {
		const timeZone = next[timeZoneName] || ANALYTICS_DEFAULT_TIME_ZONE;
		const startDate = formatAnalyticsStartDate(next[startName], timeZone);
		const endDate = formatAnalyticsEndDate(next[endName], upperBound, timeZone);
		if (startDate) next[startName] = startDate;
		else delete next[startName];
		if (endDate) next[endName] = endDate;
		else delete next[endName];
	});

	ANALYTICS_TIME_ZONE_PARAM_NAMES.forEach((timeZoneName) => delete next[timeZoneName]);

	return next;
};
